import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamRestartRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamRestartRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamRestartRequestDTORaw) {
    JsonSchemaValidator.assert(RoomStreamRestartRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      },
      additionalProperties: false
    };
  }
}

export interface RoomStreamRestartRequestDTORaw {
  roomId: RoomId;
  streamId: StreamId;
}
